import Vimeo from '@u-wave/react-vimeo';
import { Button, Modal } from 'antd';
import * as React from 'react';

interface IVideoOptions {
  title: string;
  vimeoId: string | number;
}

interface IVideoModalContext {
  openVideo: (options: IVideoOptions) => void;
}

const VideoModalContext = React.createContext<IVideoModalContext | null>(null);

export const VideoModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const [videoPaused, setVideoPaused] = React.useState(false);
  const [videoInfo, setVideoInfo] = React.useState({ title: '', vimeoId: 0 });

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const openVideo = (options: any) => {
    setVideoInfo(options);
    setOpen(true);
    setVideoPaused(false);
  };

  const [state] = React.useState({
    openVideo,
  });

  const handleClose = () => {
    setVideoPaused(true);
  };

  const onLoaded = () => {
    setVideoPaused(false);
  };

  // Had to use this hacky way of closing the modal.
  // If the modal closes before the video is paused,
  // the video does not pause.
  React.useEffect(() => {
    if (videoPaused) {
      setOpen(false);
    }
  }, [videoPaused]);

  return (
    <VideoModalContext.Provider value={state}>
      {children}

      <Modal
        title={videoInfo.title}
        open={open}
        onCancel={handleClose}
        width={1280}
        footer={[
          <Button
            key='back'
            onClick={handleClose}
          >
            Close
          </Button>,
        ]}
      >
        <Vimeo
          video={videoInfo.vimeoId}
          paused={videoPaused}
          onLoaded={onLoaded}
          autoplay
          responsive
          showByline={false}
          showTitle={false}
        />
      </Modal>
    </VideoModalContext.Provider>
  );
};

export function useVideoModal() {
  const context = React.useContext(VideoModalContext);

  if (context === undefined) {
    throw new Error('useVideoModal must be used within a VideoModalProvider');
  }

  return context;
}
